<div class="address-edit-wrap">
  <form [formGroup]="addressForm">
    <div class="flex-between mb40">
      <div class="flex-1 mr20">
        <label for="companyName1">{{'COMPANY_NAME_1' | translate}}*</label>
        <input nz-input  type="text" id="companyName1" formControlName="companyName1">
        <div class="error-message" *ngIf="addressForm.get('companyName1')?.touched && addressForm.get('companyName1')?.hasError('required')">
          {{'COMPANY_NAME_1' | translate}} {{'IS_REQUIRED' | translate}}
        </div>
      </div>
  
      <div class="flex-1">
        <label for="companyName2">{{'COMPANY_NAME_2' | translate}}</label>
        <input nz-input  type="text" id="companyName2" formControlName="companyName2">
      </div>
    </div>
    <div class="flex-between mb40">
      <div class="flex-1 mr20">
        <label for="street"> {{'STREET' | translate}}*</label>
        <input nz-input  type="text" id="street" formControlName="street">
        <div class="error-message" *ngIf="addressForm.get('street')?.touched && addressForm.get('street')?.hasError('required')">
         {{'STREET' | translate}} {{'IS_REQUIRED' | translate}}
        </div>
      </div>

  
      <div class="flex-1">
        <label for="streetNumber">{{'STREET_NUMBER' | translate}}</label>
        <input nz-input   type="text" id="streetNumber" formControlName="streetNumber">
      </div>
    </div>
    <div class="flex-between mb40">
      <div class="flex-1 mr20">
        <label for="postcode">{{'POSTCODE' | translate}}*</label>
        <input nz-input  type="text" id="postcode" formControlName="postcode">
        <div class="error-message" *ngIf="addressForm.get('postcode')?.touched && addressForm.get('postcode')?.hasError('required')">
          {{'POSTCODE' | translate}} {{'IS_REQUIRED' | translate}}
        </div>
      </div>
  
      <div class="flex-1">
        <label for="city">{{'CITY' | translate}}*</label>
        <input nz-input  type="text" id="city" formControlName="city">
        <div class="error-message" *ngIf="addressForm.get('city')?.touched && addressForm.get('city')?.hasError('required')">
          {{'CITY' | translate}} {{'IS_REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <div class="flex-between mb40">
      <div class="flex-1 mr20">
        <label for="country">{{'COUNTRY' | translate}}*</label>
        <nz-select formControlName="country" class="w100"  [nzSuffixIcon]="suffixSearch">
          <nz-option *ngFor="let item of countryList" [nzValue]="item.value"
            [nzLabel]="item.label"></nz-option>
        </nz-select>
        <div class="error-message" *ngIf="addressForm.get('country')?.touched && addressForm.get('country')?.hasError('required')">
          {{'COUNTRY' | translate}} {{'IS_REQUIRED' | translate}}
        </div>
      </div>
  
      <div class="flex-1">
        <label for="state">{{'STATE' | translate}}*</label>
        <nz-select formControlName="state" class="w100"  [nzSuffixIcon]="suffixSearch">
          <nz-option *ngFor="let item of stateList" [nzValue]="item.value"
            [nzLabel]="item.label"></nz-option>
        </nz-select>
        <div class="error-message" *ngIf="addressForm.get('state')?.touched && addressForm.get('state')?.hasError('required')">
          {{'STATE' | translate}} {{'IS_REQUIRED' | translate}}
        </div>
        <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
      </div>
    </div>
    <div class="flex-between mb40">
      <div class="flex-1 mr20">
        <label for="phone">{{'PHONE' | translate}}</label>
        <input nz-input  type="text" id="phone" formControlName="phone">
      </div>
      <div class="flex-1"></div>
    </div>
    <div class="operation flex mt20">
      <div class="default-small-btn flex-center mr20" (click)="closeModal()">
        <svg-icon [iconName]="'close.svg'" [isUrl]="false" [size]="16" class="btn-r"></svg-icon>
        <span>{{'CLOSE' | translate}}</span>
      </div>
      <div class="primary-small-btn flex-center"  (click)="saveAddress()">
        <svg-icon [iconName]="'right.svg'" [isUrl]="false" [size]="16" class="btn-r"></svg-icon>
        <span> {{'CONFIRM' | translate}}</span>
      </div>
    </div> 
  
    
  </form>
</div>
